import { KeyframeConfig } from "../../../models/animations.model";
import { getHideWithOpacityKeyframe, getShowGroupObjectsBaseKeyframe } from "./showHide";

export const getRisingStrongInBaseKeyframe = (
  letterObjects: fabric.Object[],
  opacity: number,
  delay: number,
  duration: number,
  height: number
): KeyframeConfig[] => {
  return letterObjects.flatMap((letterObject: any, index: number) => {
    return [
      {
        option: {
          keyframes: [
            {
              opacity: 0,
              top: letterObject.top + height,
              duration: 1,
            },
            { opacity, top: letterObject.top, duration },
          ],
          targets: letterObject,
          delay: delay * (index + 1),
        },
      },
    ];
  });
};

export const getRisingStrongInKeyframes = (
  fabricObject: any,
  opacity: number,
  delay: number,
  duration: number,
  height: number,
  originalObject: any
): KeyframeConfig[] => {
  const hideKeyframe = getHideWithOpacityKeyframe(originalObject);
  const showLettersKeyframe = getShowGroupObjectsBaseKeyframe(
    fabricObject,
    fabricObject.getObjects().slice(1),
    0
  );

  const risingStrongInBaseKeyframe = getRisingStrongInBaseKeyframe(
    fabricObject,
    opacity,
    delay,
    duration / 2,
    height
  );

  return hideKeyframe.concat(showLettersKeyframe, risingStrongInBaseKeyframe);
};

export const getRisingStrongOutBaseKeyframe = (
  letterObjects: fabric.Object[],
  opacity: number,
  delay: number,
  duration: number,
  height: number
): KeyframeConfig[] => {
  return letterObjects.flatMap((letterObject: any, index: number) => {
    return [
      {
        option: {
          keyframes: [
            {
              opacity,
              top: letterObject.top,
              duration: 1,
            },
            {
              opacity: 0,
              top: letterObject.top - height,
              duration,
            },
          ],
          targets: letterObject,
          delay: delay * (index + 1),
        },
      },
    ];
  });
};

export const getRisingStrongOutKeyframes = (
  fabricObject: any,
  opacity: number,
  delay: number,
  duration: number,
  height: number,
  originalObject: any
): KeyframeConfig[] => {
  const hideKeyframe = getHideWithOpacityKeyframe(originalObject);
  const showLettersKeyframe = getShowGroupObjectsBaseKeyframe(
    fabricObject,
    fabricObject.getObjects().slice(1),
    opacity
  );

  const risingStrongOutBaseKeyframe = getRisingStrongOutBaseKeyframe(
    fabricObject,
    opacity,
    delay,
    duration / 2,
    height
  );

  return hideKeyframe.concat(showLettersKeyframe, risingStrongOutBaseKeyframe);
};
